import { StyleSheet } from 'aphrodite';
import { brandPrimaryText } from '../../../styles/colors';
import { THEME } from '../../../components-v2/Theme/theme';

const { spacing, colors } = THEME;

export const styleSheet = StyleSheet.create({
	container: {
		boxSizing: 'border-box',
		width: '100%',
		height: '100%',
		paddingTop: spacing.lg,
		backgroundColor: 'transparent !important',
	},
	databoardContainer: {
		boxSizing: 'border-box',
		width: '100%',
		height: '100%',
		backgroundColor: 'transparent !important',
	},
	searchInput: {
		width: 400,
		minWidth: 250,
		flexShrink: 1,
		borderRadius: 8,
		backgroundColor: colors.background.light,
	},
	titleCell: {
		maxWidth: 300,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
	},
	contactsCell: {
		display: 'flex',
		alignItems: 'center',
		gap: 4,
	},
	moreContactsButton: {
		border: 'none',
		background: 'none',
		color: brandPrimaryText,
		fontSize: 12,
		cursor: 'pointer',
		padding: 0,
		whiteSpace: 'nowrap',
		fontWeight: 500,
		':hover': {
			textDecoration: 'underline',
		},
	},
	moreContactsPopover: {
		display: 'flex',
		flexDirection: 'column',
		gap: 4,
		padding: 8,
		maxWidth: 300,
	},
	pastRow: {
		color: colors.text.light,
		fontStyle: 'italic',
	},
});
